// extracted by mini-css-extract-plugin
export default {"container":"_1C7Vz","link":"g0-WV","term":"_1o7Ak"};